const initialState = () => ({
  accounts: [], // Cuentas de usuarios listadas
  totalAccounts: 0, // Cantidad de cuentas de usuario que existen
})

export default initialState
